import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const DIET_TYPES = ["Wellness", "Vegetarian", "Bland", "ESR", "CKD3", "Pescatarian", "GDM", "Well+"];
const DIET_CODES = [];
for (let w = 1; w <= 5; w++) for (let p = 1; p <= 7; p++) DIET_CODES.push(`${w}.${p}`);

export default function AddMeal() {
  const nav = useNavigate();
  const [form, setForm] = useState({
    diet_type: "Wellness",
    diet_code: "1.1",
    starting_meals: 0,
    par_level: 288,
    target_stock: 576,
    location: "",
    unit: 1, basket: 12, box: 20, half_rack: 144, full_rack: 288,
  });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        diet_type: form.diet_type,
        diet_code: form.diet_code,
        starting_meals: Number(form.starting_meals),
        par_level: Number(form.par_level),
        target_stock: Number(form.target_stock),
        location: form.location,
        conversions: {
          unit: Number(form.unit), basket: Number(form.basket), box: Number(form.box),
          half_rack: Number(form.half_rack), full_rack: Number(form.full_rack),
        },
      };
      const { data } = await api.post("/meals", payload);
      toast.success(`Created meal record ${data.diet_type} — ${data.diet_code}`);
      nav("/admin/meal-codes");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-4 md:p-6 max-w-2xl">
      <Link to="/admin" className="text-xs text-muted-foreground hover:text-primary">← Admin</Link>
      <div className="my-3">
        <div className="label-tech mb-1">Configuration</div>
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight">Add New Meal Record</h1>
      </div>
      <form onSubmit={submit} className="card-flat border-border p-4 space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs">
            <div className="label-tech mb-1">Diet Type</div>
            <select value={form.diet_type} onChange={(e) => setForm({ ...form, diet_type: e.target.value })} className="w-full h-10 px-2 border border-border bg-background rounded-sm text-sm">
              {DIET_TYPES.map((t) => (<option key={t} value={t}>{t}</option>))}
            </select>
          </label>
          <label className="text-xs">
            <div className="label-tech mb-1">Diet Code</div>
            <select value={form.diet_code} onChange={(e) => setForm({ ...form, diet_code: e.target.value })} className="w-full h-10 px-2 border border-border bg-background rounded-sm text-sm font-mono">
              {DIET_CODES.map((c) => (<option key={c} value={c}>{c}</option>))}
            </select>
          </label>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs">
            <div className="label-tech mb-1">Starting Meals</div>
            <input type="number" min="0" value={form.starting_meals} onChange={(e) => setForm({ ...form, starting_meals: e.target.value })} className="w-full h-10 px-2 border border-border bg-background rounded-sm text-sm" />
          </label>
          <label className="text-xs">
            <div className="label-tech mb-1">Location</div>
            <input type="text" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} className="w-full h-10 px-2 border border-border bg-background rounded-sm text-sm" />
          </label>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs">
            <div className="label-tech mb-1">PAR Level</div>
            <input type="number" min="0" value={form.par_level} onChange={(e) => setForm({ ...form, par_level: e.target.value })} className="w-full h-10 px-2 border border-border bg-background rounded-sm text-sm" />
          </label>
          <label className="text-xs">
            <div className="label-tech mb-1">Target Stock</div>
            <input type="number" min="0" value={form.target_stock} onChange={(e) => setForm({ ...form, target_stock: e.target.value })} className="w-full h-10 px-2 border border-border bg-background rounded-sm text-sm" />
          </label>
        </div>
        <div>
          <div className="label-tech mb-2">Conversions (meals per unit)</div>
          <div className="grid grid-cols-5 gap-2">
            {["unit", "basket", "box", "half_rack", "full_rack"].map((k) => (
              <label key={k} className="text-xs">
                <div className="label-tech text-[9px] mb-1">{k.replace("_", " ")}</div>
                <input type="number" min="1" value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="w-full h-9 px-2 border border-border bg-background rounded-sm text-sm font-mono" />
              </label>
            ))}
          </div>
        </div>
        <button type="submit" disabled={saving} className="btn-hard w-full h-11 bg-primary text-primary-foreground font-bold uppercase tracking-widest text-xs rounded-sm hover:bg-orange-600 hover:text-white disabled:opacity-60">
          {saving ? "Saving…" : "Create Meal Record"}
        </button>
      </form>
    </div>
  );
}
